// Domain management utilities
export const DEFAULT_DOMAINS = [
  {
    id: 'go-nurulquran',
    domain: 'go.nurulquran.com',
    name: 'Go NurulQuran',
    active: true,
    primary: true
  },
  {
    id: 'link-nurulquran',
    domain: 'link.nurulquran.com',
    name: 'Link NurulQuran',
    active: true,
    primary: false
  }
];

export const getDomains = () => {
  const saved = localStorage.getItem('shortener_domains');
  if (saved) {
    try {
      return JSON.parse(saved);
    } catch (e) {
      console.error('Error parsing saved domains:', e);
    }
  }
  return DEFAULT_DOMAINS;
};

export const saveDomains = (domains) => {
  localStorage.setItem('shortener_domains', JSON.stringify(domains));
};

export const addDomain = (domain, name) => {
  const domains = getDomains();
  const newDomain = {
    id: `domain-${Date.now()}`,
    domain: domain.replace(/^https?:\/\//, '').replace(/\/$/, ''),
    name: name || domain,
    active: true,
    primary: false
  };
  
  const updatedDomains = [...domains, newDomain];
  saveDomains(updatedDomains);
  return updatedDomains;
};

export const removeDomain = (domainId) => {
  const domains = getDomains();
  const updatedDomains = domains.filter(d => d.id !== domainId && !d.primary);
  saveDomains(updatedDomains);
  return updatedDomains;
};

export const toggleDomainActive = (domainId) => {
  const domains = getDomains();
  const updatedDomains = domains.map(d => 
    d.id === domainId ? { ...d, active: !d.active } : d
  );
  saveDomains(updatedDomains);
  return updatedDomains;
};

export const getActiveDomains = () => {
  return getDomains().filter(d => d.active);
};

export const getPrimaryDomain = () => {
  const domains = getDomains();
  return domains.find(d => d.primary) || domains[0];
};